import { useIsAuthenticated } from "@azure/msal-react";
import { HubConnection, HubConnectionState } from "@microsoft/signalr";
import { useEffect, useState } from "react";
import { useSubscribeMutation, useUnsubscribeMutation } from "../../services/objects/objectHubApi";
import { ObjectsHubConnector } from '../../services/objects/objectsHub'

const hub = ObjectsHubConnector.getInstance();



interface useObjectsHubConnectionOutput {
    connection?: HubConnection,
}

function useObjectsHubConnection(): useObjectsHubConnectionOutput {
    const isAuthenticated = useIsAuthenticated();
    const [ connection, setbConnection ] = useState<HubConnection>();

    const [subscribe, subscribeResult] = useSubscribeMutation();
    const [unsubscribe, unsubscribeResult] = useUnsubscribeMutation();
    
    useEffect(() => {
        if ( !isAuthenticated)
          return;
        if ( connection )
          return;

        const c = hub;
        setbConnection(c.connection);
    }, [isAuthenticated]);
  
    useEffect(() => {
        if (connection) {
            const startConnction = async () => {
                if ( connection.state !== HubConnectionState.Disconnected)
                    return;
                    
                connection.start()
                    .then(async result => {
                        console.info('ObjectsHub: Connected!');
                        await subscribe();
                        console.info('ObjectsHub: Subscribed!');
                    })
                    .catch(e => console.error('ObjectsHub: Connection failed: ', e));
            }
            // call the function
            startConnction()
                // make sure to catch any error
                .catch(e => console.error('ObjectsHub: startConnction() failed: ', e));
        }
    }, [connection]);


    return {
        connection: connection
    }
}

export default useObjectsHubConnection